import { Component, h, State } from '@stencil/core';
import spacetime, { Spacetime } from 'spacetime';
import { selection } from '../../store/selection.store';
import { schedule } from '../../store/schedule.store';
import { settings } from '../../store/settings.store';
import { openAccountFlow } from '../../modals/account.modal';


@Component({
  tag: 'tambr-calendar-dates',
  styleUrl: 'tambr-calendar-dates.css',
  shadow: true,
})
export class TambrCalendarDates {

  startWeekDay = settings.businessSettings?.scheduleSettings?.startWeekOn || 'monday';

  @State() selectedWeek = spacetime( selection.date ).weekStart( this.startWeekDay ).startOf('week');
  @State() selectedMonth = this.selectedWeek;


  selectDate( date: string ) {
    selection.date = date;
  }


  getFirstAvailableInArray( array: Spacetime[] ) {
    let firstAvailableDate = null;
    for ( const date of array ) {
      if ( schedule.availableDates.includes( date.format('iso-short') ) ) {
        firstAvailableDate = date;
        break;
      }
    }
    return firstAvailableDate;
  }

  getFirstAvailableWeekDate( startDate: Spacetime ) {
    const endDate = startDate.endOf( 'week' );
    const weekArray = startDate.each( 'date', endDate );
    return this.getFirstAvailableInArray( weekArray );
  }

  getLastAvailableWeekDate( startDate: Spacetime ) {
    const endDate = startDate.endOf( 'week' );
    const weekArray = startDate.each( 'date', endDate );
    return this.getFirstAvailableInArray( weekArray.reverse() );
  }

  getFirstAvailableMonthDate( date: Spacetime ) {
    const startDate = date.startOf('month');
    const endDate = date.endOf('month');
    const monthArray = startDate.each( 'date', endDate );
    return this.getFirstAvailableInArray( monthArray );
  }


  selectMonth( newMonth: Spacetime ) {
    this.selectedMonth = newMonth;
    const newDate = this.getFirstAvailableMonthDate( newMonth );
    this.selectDate( newDate.format('iso-short') );
    this.selectedWeek = newDate.startOf('week');
  }

  selectWeek( newWeek: Spacetime ) {
    this.selectedWeek = newWeek;
    this.selectedMonth = this.getLastAvailableWeekDate( newWeek );
    const newDate = this.getFirstAvailableWeekDate( newWeek );
    this.selectDate( newDate.format('iso-short') );
  }


  prevWeekDisabled() {
    const previousWeek = this.selectedWeek.last('week');
    return !this.getFirstAvailableWeekDate( previousWeek );
  }

  prevWeek() {
    const previousWeek = this.selectedWeek.last('week');
    this.selectWeek( previousWeek );
  }


  nextWeekDisabled() {
    const nextWeek = this.selectedWeek.next('week');
    return !this.getFirstAvailableWeekDate( nextWeek );
  }

  nextWeek() {
    const nextWeek = this.selectedWeek.next('week');
    this.selectWeek( nextWeek );
  }


  prevMonthDisabled() {
    const previousMonth = this.selectedMonth.last('month');
    return !this.getFirstAvailableMonthDate( previousMonth );
  }

  prevMonth() {
    const previousMonth = this.selectedMonth.last('month');
    this.selectMonth( previousMonth );
  }


  nextMonthDisabled() {
    const nextMonth = this.selectedMonth.next('month');
    return !this.getFirstAvailableMonthDate( nextMonth );
  }

  nextMonth() {
    const nextMonth = this.selectedMonth.next('month');
    this.selectMonth( nextMonth );
  }


  render() {
    return ([
      this.renderHeader(),

      <div class="dates-row">
        { this.leftArrow() }

        <div class="days-container">
          { this.renderDates() }
        </div>

        { this.rightArrow() }
      </div>
    ]);
  }


  renderHeader() {
    return (
      <div class='header'>
        <div class='account'>
          { this.renderAccountButton() }
        </div>
        { this.renderMonthSwitch() }
      </div>
    );
  }

  renderAccountButton() {
    return (
      <button class='tambr-stroked-button account-link' 
        disabled={ !!settings.demo || settings.appCheckFailed } 
        onClick={ () => openAccountFlow() }>
          <tambr-icon type='user'></tambr-icon>
          <span>My account</span>
      </button>
    );
  }

  renderMonthSwitch() {
    return (
      <div class='month-switch'>
        <button class='tambr-arrow-button' onClick={ () => this.prevMonth() } disabled={ this.prevMonthDisabled() } >
          <tambr-icon type='left-arrow' class='arrow'></tambr-icon>
        </button>

        <span class='month-label'>{ this.selectedMonth.format('month-short') }</span>

        <button class='tambr-arrow-button' onClick={ () => this.nextMonth() } disabled={ this.nextMonthDisabled() } >
          <tambr-icon type='right-arrow' class='arrow'></tambr-icon>
        </button>
      </div>
    )
  }

  renderDates() {
    const weekEnd = this.selectedWeek.endOf('week');
    return this.selectedWeek.each('day', weekEnd).map( date => {
      const dateStr = date.format('iso-short');
      const selected = selection.date === dateStr;
      const disabled = date.isBefore( spacetime().startOf('day') ) || !schedule.availableDates.includes( dateStr );
      const buttonClass = {
        'date-button': true,
        'selected': selected,
        'disabled': disabled
      }
      return (
        <button class={ buttonClass }
          onClick={ () => this.selectDate( dateStr ) }>
            <span class='day-label'>{ date.format('day-short') }</span>
            <span class='date-label'>{ date.date() }</span>
        </button>
      );
    });
  }

  leftArrow() {
    return (
      <button class='tambr-arrow-button' onClick={ () => this.prevWeek() } disabled={ this.prevWeekDisabled() } >
        <tambr-icon type='left-arrow' class='arrow'></tambr-icon>
      </button>
    );
  }

  rightArrow() {
    return (
      <button class='tambr-arrow-button' onClick={ () => this.nextWeek() } disabled={ this.nextWeekDisabled() } >
        <tambr-icon type='right-arrow' class='arrow'></tambr-icon>
      </button>
    );
  }

}
